import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { destroySlickCarousel, initSlickWhenReady } from '../../Utils/carouselHelpers';
import { mapReviewItem } from '../../Utils/reviewHelpers';
import { getReviews } from '../../Utils/api';
import { useLanguage } from '../../i18n/LanguageContext';
import { HOME_SECTIONS } from '../../i18n/sectionCopy';
import { useLocalizedStatic } from '../../i18n/useLocalizedStatic';
import HomeTeamSection from './HomeTeamSection';
import PartnerLogos from './PartnerLogos';

const img = (path) => `${process.env.PUBLIC_URL}/assets/images/${path}`;

const SLICK_OPTIONS = {
  autoplay: true,
  infinite: true,
  centerMode: false,
  arrows: true,
  dots: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 992, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    { breakpoint: 991, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
};

function HomeReviewsSection() {
  const { locale, revision } = useLanguage();
  const copy = useLocalizedStatic(HOME_SECTIONS);
  const testiSlideRef = useRef(null);
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    getReviews()
      .then((data) => {
        if (!active) return;
        const items = (data || [])
          .map(mapReviewItem)
          .filter((item) => item.quote && item.name && item.photo);
        setReviews(items);
      })
      .catch((err) => {
        if (!active) return;
        console.warn('Failed to load client reviews:', err?.message || err);
        setReviews([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [locale, revision]);

  useLayoutEffect(() => {
    if (!reviews.length) return undefined;

    const testiEl = testiSlideRef.current;
    destroySlickCarousel(testiEl);
    const cleanup = initSlickWhenReady(testiEl, SLICK_OPTIONS);

    return () => {
      cleanup?.();
      destroySlickCarousel(testiEl);
    };
  }, [reviews]);

  return (
    <div
      id="rs-testimonial"
      className="rs-testimonial testimonial-style1 gray-bg pt-120 pb-120 md-pt-80 md-pb-80"
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-6 md-mb-50">
            <div className="sec-title mb-45">
              <span className="sub-text">
                <img src={img('shape-1.png')} alt="Images" />
                {copy.testimonialsSub}
              </span>
              <h2 className="title">{copy.testimonialsTitle}</h2>
            </div>
            <div className="testi-item-content">
              {loading && (
                <p className="home-reviews-loading">{copy.reviewsLoading}</p>
              )}
              {!loading && reviews.length === 0 && (
                <p className="home-reviews-empty">
                  {copy.reviewsEmpty}
                </p>
              )}
              {!loading && reviews.length > 0 && (
                <div className="slider testi-slide-1" ref={testiSlideRef}>
                  {reviews.map((item) => (
                    <div key={item.id} className="testi-item">
                      <div className="item-content">
                        <span>
                          <img src={img('testimonial/style1/quote.png')} alt="" />
                        </span>
                        <p>{item.quote}</p>
                      </div>
                      <div className="testi-content">
                        {item.photo ? (
                          <div className="image-wrap home-review-photo">
                            <img src={item.photo} alt={item.name} loading="lazy" />
                          </div>
                        ) : (
                          <div className="image-wrap home-review-photo home-review-photo--placeholder" aria-hidden="true">
                            <span>{item.name.charAt(0)}</span>
                          </div>
                        )}
                        <div className="testi-information">
                          <div className="testi-name">{item.name}</div>
                          <span className="testi-title">{item.title}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className="col-lg-6">
            <HomeTeamSection />
          </div>
        </div>
        <PartnerLogos className="rs-partner partner-main-home pt-70 md-pt-50" withContainer={false} />
      </div>
    </div>
  );
}

export default HomeReviewsSection;
